module.exports = __webpack_public_path__ + "static/media/notification.338126f5.svg";